/* eslint-disable no-magic-numbers */
/* eslint-disable flowtype/require-parameter-type */
/* eslint-disable flowtype/require-return-type */
/*
 * @providesModule PhoneNumber
 *
 */

import _ from 'lodash';
import Country, {CountryType} from 'Country';
import number_type from './NumberType.json';
import googleLibphonenumber from 'google-libphonenumber';

const phoneUtil = googleLibphonenumber.PhoneNumberUtil.getInstance();

class PhoneNumber {
  private static instance: PhoneNumber | null = null;

  private constructor() {}

  static getInstance(): PhoneNumber {
    if (!PhoneNumber.instance) {
      PhoneNumber.instance = new PhoneNumber();
    }
    return PhoneNumber.instance;
  }

  getAllCountries(): CountryType[] {
    return Country.getAll();
  }

  getDialCode(number: string): string {
    let dialCode = '';

    // Only process international numbers (starting with a plus)
    if (number.charAt(0) === '+') {
      let numericChars = '';

      // Iterate over characters in the number
      for (let i = 0; i < number.length; i++) {
        const c = number.charAt(i);

        if (this.isNumeric(c)) {
          numericChars += c;

          // Check if current numericChars match a valid dial code
          const countryCodes = Country.getCountryCodes();
          if (countryCodes[numericChars]) {
            dialCode = number.substr(0, i + 1);
          }

          // Longest dial code is 4 characters
          if (numericChars.length === 4) {
            break;
          }
        }
      }
    }

    return dialCode;
  }

  getNumeric(str: string): string {
    return str.replace(/\D/g, '');
  }

  isNumeric(n: string): boolean {
    return !isNaN(parseFloat(n)) && isFinite(Number(n));
  }

  getCountryCodeOfNumber(number: string): string {
    const dialCode = this.getDialCode(number);
    const numeric = this.getNumeric(dialCode);
    const countryCode = Country.getCountryCodes()[numeric];

    // countryCode[0] can be null -> get first element that is not null
    if (countryCode) {
      return _.first(countryCode.filter((iso2) => iso2)) || '';
    } else {
      return '';
    }
  }

  parse(number: string, iso2: string) {
    try {
      return phoneUtil.parse(number, iso2);
    } catch (err) {
      console.debug('Exception was thrown:', err);
      return null;
    }
  }

  isValidNumber(number: string, iso2: string): boolean {
    const phoneInfo = this.parse(number, iso2);
    return phoneInfo ? phoneUtil.isValidNumber(phoneInfo) : false;
  }

  getNumberType(number: string, iso2: string): string | undefined {
    const phoneInfo = this.parse(number, iso2);
    let type = -1;
    if (phoneInfo) {
      type = phoneUtil.getNumberType(phoneInfo);
    }
    return _.findKey(number_type, (noType) => noType === type);
  }

  getCountryDataByCode(iso2: string): CountryType | undefined {
    return Country.getCountryDataByCode(iso2);
  }
}

export default PhoneNumber.getInstance();
